/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-03-02, 15:17:24
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-06, 14:44:05
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import { mapActions } from 'vuex';
import { API_URL } from '@/config';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'DownloadInvoice',

  props: ['invoiceDescription'],

  computed: {
    year() {
      return this.invoiceDescription.split('/')[2];
    },
    month() {
      return this.invoiceDescription.split('/')[1];
    },
  },

  methods: {
    ...mapActions(['downloadInvoiceFile']),
    downloadFile() {
      const params = {
        year: this.year,
        month: this.month,
      };
      this.downloadInvoiceFile(params);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/DownloadInvoice/component.js